import { apiGet } from '../../lib/apiClient'
import type { IDeploymentErrorsService } from './IDeploymentErrorsService.interface'
import type { RunErrorsResult } from '../../types/deploymentErrors.types'

/** Real provider — GET /api/runs/:id/errors (host flattens per-record failures). */
export class HttpDeploymentErrorsService implements IDeploymentErrorsService {
  getErrors(runId: string): Promise<RunErrorsResult> {
    return apiGet<RunErrorsResult>(`/api/runs/${encodeURIComponent(runId)}/errors`)
  }
}
